import {
    useChapterCues,
    useChaptersStore,
} from '@components/@shared/Chapters/@hooks';
import {MeinText} from '@components/@typography/MeinText';
import {useLiveEventQuery} from '@components/LiveEvent/@hooks';
import {findRecordingById} from '@components/LiveEvent/@utils/findRecordingById';
import {useMemo} from 'react';
import {VideoControlsItem} from '../Item/VideoControlsItem';
import styles from './VideoChapterTitle.module.css';

export const VideoChapterTitle = () => {
    const {
        query: {data: webinar},
    } = useLiveEventQuery();

    const {recordings} = webinar!;

    const currentVideoId = useChaptersStore(s => s.videoId);

    const currentRecording = findRecordingById(
        recordings,
        currentVideoId,
    )?.recording;

    const chapterMarks = currentRecording?.chapter_marks ?? [];
    const duration = currentRecording?.duration;

    const {cues} = useChapterCues(chapterMarks, duration);

    const activeChapterTimestamp = useChaptersStore(
        s => s.activeChapterTimestamp,
    );

    const activeChapter = useMemo(() => {
        if (!cues || !cues.length) {
            return null;
        }

        return cues.find(
            c =>
                c.startTime <= activeChapterTimestamp &&
                c.endTime > activeChapterTimestamp,
        );
    }, [activeChapterTimestamp, cues]);

    if (!activeChapter) {
        return null;
    }

    return (
        <VideoControlsItem>
            <MeinText size="m" className={styles.chapterTitle} linesToClamp={1}>
                {activeChapter.title}
            </MeinText>
        </VideoControlsItem>
    );
};
